import React from 'react'
import PropTypes from 'prop-types'

function CardGroup ({ children, className = null }) {
  const classNames = [
    'group',
    'space-y-6',
    'sm:space-y-8',
    className
  ]
  return (
    <div className={classNames.join(' ')}>
      {children}
    </div>
  )
}

export default CardGroup
